import { render, staticRenderFns } from "./DialogDetailEvaluate.vue?vue&type=template&id=2fbfb817"
import script from "./DialogDetailEvaluate.vue?vue&type=script&lang=js"
export * from "./DialogDetailEvaluate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports